"use strict";

/**
 * Binds event listeners to input fields with the class "uppercase-only" to automatically convert their values to uppercase.
 */
const bindEvents = () => {
    const uppercaseFields = document.querySelectorAll(".uppercase-only");

    uppercaseFields.forEach((field) => {
        field.addEventListener("keyup", function () {
            field.value = field.value.toLocaleUpperCase();
        });
    });
};

module.exports = {
    bindEvents,
};
